<template>
	<div class="action-costs">

		<v-layout row wrap>
			<v-flex d-flex xs12>
				<v-card color="grey">
					<v-card-text>
						<h2>Koszty programowe</h2>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<div v-for="(action, actionIndex) in actions"
			:key="action.name + costsKeyValue + actionIndex.toString()"
		>
			<v-layout row wrap>
				<v-flex d-flex xs11>
					<v-card color="grey lighten-2">
						<v-card-text>Nr {{action.serialNumber}} &emsp; {{action.action}}
							<egranty-icon-button
								v-if="!readonly"
								icon="add_circle"
								label="Dodaj nowy koszt"
								for="actions-costs-add-new-cost"
								id="actions-costs-add-new-cost"
								@click="addCost(actionIndex)"
							></egranty-icon-button>
						</v-card-text>
					</v-card>
				</v-flex>

				<v-flex d-flex xs1>
					<v-card color="grey lighten-2" class="d-flex justify-center align-center">
						<v-card-text>
							<strong>
								{{formatMoney(actionsTotal[actionIndex])}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
			<div
				v-for="(cost, costIndex) in costs[actionIndex]"
				:key="costIndex"
			>
				<v-layout row wrap>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text>
								{{action.serialNumber}}.{{cost.serialNumber}} &emsp;
							</v-card-text>
							<egranty-icon-button
								class="up-button"
								v-if="!readonly"
								@click="moveAdministrativeUp(actionIndex, costIndex)"
								icon="arrow_drop_up"
								color="primary"
								label="Przesuń w górę"
								for="administrative-move-up-this-cost"
								id="administrative-move-up-this-cost"
							></egranty-icon-button>
							<egranty-icon-button
								class="down-button"
								v-if="!readonly"
								@click="moveAdministrativeDown(actionIndex, costIndex)"
								icon="arrow_drop_down"
								color="primary"
								label="Przesuń w dół"
								for="administrative-move-down-this-cost"
								id="administrative-move-down-this-cost"
							></egranty-icon-button>
							<egranty-icon-button
								v-if="!readonly && isLastCost(actionIndex, costIndex)"
								icon="add_circle"
								label="Dodaj nowy koszt"
								class="bottom-button"
								small
								for="actions-costs-add-new-cost-bottom"
								id="actions-costs-add-new-cost-bottom"
								@click="addCost(actionIndex)"
							></egranty-icon-button>
						</v-card>
					</v-flex>
					<v-flex d-flex xs4>
						<v-card color="grey lighten-3">
							<v-card-text>
								<costs-text-input-field
									:disabled="readonly"
									class="action-costs-cost-name"
									label="Nazwa kosztu"
									for="actions-costs-name-cost"
									id="actions-costs-name-cost"
									v-model="cost.name"
									@input="sync"
								></costs-text-input-field>
								<div class="action-costs-delete">
									<egranty-icon-button
										v-if="!readonly"
										@click="deleteCost(actionIndex, costIndex)"
										color="lightred"
										icon="delete"
										label="Usuń ten koszt"
										for="actions-costs-delete-this-cost"
										id="actions-costs-delete-this-cost"
									></egranty-icon-button>
								</div>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs2>
						<v-card color="grey lighten-3">
							<v-card-text>
								<costs-text-input-field
									:disabled="readonly"
									class="action-costs-measure-name"
									label="Nazwa miary"
									for="actions-costs-name-measure"
									id="actions-costs-name-measure"
									v-model="cost.measureType"
									@input="sync"
								></costs-text-input-field>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text>
								<egranty-number-input-field
									:disabled="readonly"
									class="action-costs-unit-cost"
									label="Koszt jednostkowy"
									for="actions-costs-unit-cost"
									id="actions-costs-unit-cost"
									v-model="cost.pricePerUnit"
									@input="updateCalculatedAndSync"
								></egranty-number-input-field>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text>
								<egranty-number-input-field
									:disabled="readonly"
									class="action-costs-number-units"
									label="Liczba jednostek"
									for="actions-costs-number-units"
									id="actions-costs-number-units"
									v-model="cost.unitsCount"
									@input="updateCalculatedAndSync"
								></egranty-number-input-field>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs2>
						<v-card color="grey lighten-3" class="d-flex justify-center align-center">
							<v-card-text>
								<div>
									Źródło finansowania
								</div>
								<egranty-icon-button
									v-if="!isEdited(actionIndex, costIndex) && !readonly"
									@click="startEdit(actionIndex, costIndex)"
									label="Edytuj"
									for="actions-costs-edit"
									id="actions-costs-edit"
									icon="edit"
								></egranty-icon-button>

								<egranty-icon-button
									v-if="isEdited(actionIndex, costIndex) && !readonly"
									@click="editing = false"
									label="Zakończ edycję"
									for="actions-costs-end-edit"
									id="actions-costs-end-edit"
									icon="done_outline"
								></egranty-icon-button>

								<egranty-icon-button
									v-if="isEdited(actionIndex, costIndex)"
									@click="addCostDivision(actionIndex, costIndex)"
									label="Dodaj kolejne źródło finansowania"
									for="actions-costs-cost-division"
									id="actions-costs-cost-division"
									icon="add_circle"
								></egranty-icon-button>

								<div v-if='cost.costDivisions.length < 2'>
									{{cost.costDivisions[0].type}}
								</div>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3" class="d-flex justify-center align-center">
							<v-card-text>
								<strong>
									{{formatMoney(costsTotal[actionIndex][costIndex])}}
								</strong>
							</v-card-text>
						</v-card>
					</v-flex>

				</v-layout>
				<div v-if="cost.costDivisions.length !== 1">
					<div
						v-for="(division, divisionIndex) in cost.costDivisions"
						:key="divisionIndex"
					>
						<v-layout row wrap
							v-if="divisionIndex !== 0 || isEdited(actionIndex, costIndex) || division.totalPrice > 0.001"
						>
							<v-flex d-flex xs9>
								<v-card color="grey lighten-3">
								</v-card>
							</v-flex>

							<v-flex d-flex xs2>
								<v-card color="grey lighten-3">
									<v-card-text>
										<egranty-icon-button
											v-if="isEdited(actionIndex, costIndex) && divisionIndex !== 0"
											@click="deleteCostDivision(actionIndex, costIndex, divisionIndex)"
											color="lightred"
											icon="delete"
											label="Usuń to źródło finansowania"
										></egranty-icon-button>

										<v-select
											v-if="isEdited(actionIndex, costIndex) && divisionIndex !== 0"
											aria-label="division type"
											style="padding: 0"
											v-model="division.type"
											:items='options'
											@input="sync"
										></v-select>
										<div v-if="!isEdited(actionIndex, costIndex) || divisionIndex === 0">
											{{division.type}}
										</div>
									</v-card-text>
								</v-card>
							</v-flex>

							<v-flex d-flex xs1>
								<v-card color="grey lighten-3" class="d-flex justify-center align-center">
									<v-card-text>
										<egranty-number-input-field
											v-if='isEdited(actionIndex, costIndex) && divisionIndex !== 0'
											label="kwota"
											for="actions-costs-amount"
											id="actions-costs-amount"
											v-model="cost.costDivisions[divisionIndex].totalPrice"
											@input="updateCalculatedAndSync"
										></egranty-number-input-field>
										<div v-else>
											{{formatMoney(cost.costDivisions[divisionIndex].totalPrice)}}
										</div>
									</v-card-text>
								</v-card>
							</v-flex>
						</v-layout>
					</div>
				</div>
				<div v-for="error in cost.errors" :key="error">
					<egranty-validation-error
						:error="error"
					></egranty-validation-error>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	import EgrantyIconButton from "../../../../../genericComponents/EgrantyIconButton";
	import EgrantyValidationError from "../../../../../genericComponents/EgrantyValidationError";
	import EgrantyNumberInputField from "../../../../../genericComponents/EgrantyNumberInputField";
	import {Numbers} from "@/utils/Numbers";
  import CostsTextInputField from "@/view/logged/offer/components/CostsTextInputField";

	export default {
		name: "actionsCosts",
		components: {CostsTextInputField, EgrantyValidationError, EgrantyIconButton, EgrantyNumberInputField},
		props: {
			readonly: {default: false},
			actions: {},
			addCost: {},
			addCostDivision: {},
			deleteCostDivision: {},
      moveAdministrativeUp: {},
      moveAdministrativeDown: {},
			costs: {},
			costsKeyValue: {},
			deleteCost: {},
			options: {},
			sync: {type: Function},
			updateCalculated: {},
			costsTotal: {},
			actionsTotal: {},
			takenSerialNumbers: {},
		},
		mixins: [Numbers],

		data() {
			return {
				editing: false,
				editedCostIndex: "",
				editedActionIndex: "",
			};
		},

		methods: {

			updateCalculatedAndSync() {
				this.updateCalculated();
				this.sync();
			},

			startEdit(actionIndex, costIndex) {
				this.editing = true;
				this.editedCostIndex = costIndex;
				this.editedActionIndex = actionIndex;
			},

			isEdited(actionIndex, costIndex) {
				return this.editing && this.editedActionIndex === actionIndex && this.editedCostIndex === costIndex;
			},

			isLastCost(actionIndex, index) {
				return index === (this.costs[actionIndex].length - 1);
			}
		},
	};
</script>

<style>
	.action-costs-measure-name .v-label,
	.action-costs-unit-cost .v-label,
	.action-costs-number-units .v-label {
		font-size: 13px;
		overflow: visible;
		max-width: 70px;
	}

	.action-costs-delete .v-btn--icon {
		position: absolute;
		top: 30px;
		right: 10px;
	}

	.action-costs .v-card {
		width: 100% !important;
	}

	.theme--dark .grey.lighten-2 {
		background-color: #1B1B1B !important;
	}

	.theme--dark .grey.lighten-3 {
		background-color: #1B1B1B !important;
	}

	.theme--dark .grey.lighten-4 {
		background-color: #1B1B1B !important;
	}

	.source-finance-text {

		border-bottom: solid 1px rgba(0, 0, 0, 0.50);
	}

	.source-finance-text strong {
		color: rgba(0, 0, 0, 0.50);
	}

	.theme--dark .source-finance-text {
		border-bottom: solid 1px #fff;

	}

	.theme--dark .source-finance-text strong {
		color: #fff;
	}

	.bottom-button {
		position: absolute;
		bottom: 0;
		left: 0;
	}

</style>
